// import { ImageSliderModule } from 'components-modules/image-slider.js';
export default {};
